import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MarkdownEditor from '@uiw/react-markdown-editor';


const NewsForm = ({ onSubmit, initialData, onClose }) => {
  const [formData, setFormData] = useState({
    title: initialData?.title || '',
    content: initialData?.content || '',
    descriptions: initialData?.descriptions || '',
    photo: null,
    category: initialData?.category || 'telangana',
    news_field: initialData?.news_field || 'latest',
    date: initialData?.date || new Date().toISOString().split('T')[0],
  });

  useEffect(() => {
    if (initialData) {
      console.log('initialData:', initialData);
      setFormData({
        title: initialData.title || '',
        content: initialData.content || '',
        descriptions: initialData?.descriptions || '',
        photo: null,
        category: initialData.category || 'telangana',
        news_field: initialData.news_field || 'latest',
        date: initialData.date || new Date().toISOString().split('T')[0],
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append('title', formData.title);
    data.append('content', formData.content || '');
    data.append('descriptions', formData.descriptions || '');
    data.append('category', formData.category);
    data.append('news_field', formData.news_field);
    data.append('date', formData.date);

    if (formData.photo) {
      data.append('file', formData.photo);
    }

    for (let [key, value] of data.entries()) {
      console.log(`FormData: ${key}=${value}`);
    }
    onSubmit(data);
  };


  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-3xl font-bold mb-4">{initialData ? 'Edit News' : 'Add News'}</h2>
        </div>
        <div className="text-end">
          <button
            onClick={onClose}
            type="submit"
            className="text-2xl px-4 py-2 ml-2 bg-gray-200 text-gray-700 rounded-xl hover:bg-blue-600 hover:text-white"
          >
            X
          </button>
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">Title</label>
        <input
          type="text"
          name="title"
          value={formData.title}
          onChange={handleChange}
          className="mt-1 block w-full border border-gray-300 rounded-md p-2"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">Content</label>
        <textarea
          type="text"
          name="content"
          rows={3}
          value={formData.content}
          onChange={handleChange}
          className="mt-1 block w-full border border-gray-300 rounded-md p-2"
          required
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">descriptions</label>
        <MarkdownEditor
          height={200}
          preview={true}
          previewWidth="100%"
          enableScroll={true}
          value={formData?.descriptions}
          onChange={(value) => setFormData({ ...formData, descriptions: value })}
          className="mt-1 whitespace-pre-wrap break-words"
        />

      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Image</label>
        <input
          type="file"
          name="photo"
          onChange={handleChange}
          accept="image/*"
          className="block w-full border border-gray-500 rounded-md pr-3 py-0 text-lg 
               file:mr-4 file:py-2 file:px-4 
               file:border-0 file:text-3xl file:font-semibold 
               file:bg-black file:text-white hover:file:bg-gray-100 hover:file:text-gray-700"
        />
      </div>


      <div>
        <label className="block text-sm font-medium text-gray-700">Category</label>
        <select
          name="category"
          value={formData.category}
          onChange={handleChange}
          className="mt-1 block w-full border border-gray-300 rounded-md p-2"
        >
          <option value="india">India</option>
          <option value="world">World</option>
          <option value="telangana">Telangana</option>
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">News Field</label>
        <select
          name="news_field"
          value={formData.news_field}
          onChange={handleChange}
          className="mt-1 block w-full border border-gray-300 rounded-md p-2"
        >
          <option value="latest">Latest News</option>
          <option value="sports">Sports</option>
          <option value="health">Health</option>
          <option value="general">General News</option>
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">Date</label>
        <input
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          className="mt-1 block w-full border border-gray-300 rounded-md p-2"
          required
        />
      </div>
      <div>
        <button
          onClick={onClose}
          className="text-2xl mt-4 px-4 py-2 bg-gray-300 rounded-xl hover:bg-gray-400"
        >
          Close
        </button>
        <button
          type="submit"
          className="text-2xl px-4 py-2 ml-2 bg-blue-500 text-white rounded-xl hover:bg-blue-600"
        >
          Submit
        </button>
      </div>

    </form>
  );
};

NewsForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialData: PropTypes.object,
};


export default NewsForm;